var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-box"},[_c('div',{staticClass:"loading"},[_c('div',{staticClass:"shape shape-4"},[_c('div',{staticClass:"shape-4-top"}),_c('div',{staticClass:"shape-4-bottom"}),_c('div',{staticClass:"shape-4-eye"})]),_c('div',{staticClass:"shape shape-1"}),_c('div',{staticClass:"shape shape-2"}),_c('div',{staticClass:"shape shape-3"})])])
}]

export { render, staticRenderFns }